import { useMemo } from 'react';

import { WalletEntryCard } from 'core/Components';
import { toTitleCase } from 'core/Utils';
import { useNavigate } from 'react-router-dom';

import { EntryElement } from '../../../hooks/queries/Ledger/types';
import { absCentsToDollar } from '../../../utils/centsToDollar';

type Props = {
  entry: EntryElement;
};

const DonationCard = ({ entry }: Props) => {
  return (
    <WalletEntryCard
      image={entry.image}
      title={'One Time Donation'}
      subtitle={entry.payload?.cause?.name}
      amount={absCentsToDollar(entry.amount)}
      isFailed={entry.status === 'failed'}
      subText={toTitleCase(entry.status)}
    />
  );
};

const PurchaseCard = ({ entry }: Props) => {
  const navigate = useNavigate();

  const title = useMemo(() => {
    return entry.title ? `${entry.title} Purchase` : 'Purchase';
  }, [entry.title]);

  return (
    <WalletEntryCard
      image={entry.image}
      title={title}
      subtitle={entry.subtitle}
      amount={`${absCentsToDollar(entry.cashback_amount)} Back`}
      isFailed={entry.status === 'failed'}
      subText={toTitleCase(entry.status)}
      onClick={() => navigate(entry.provider_id)}
    />
  );
};

const TransferCard = ({ entry }: Props) => {
  return (
    <WalletEntryCard
      image={entry.image}
      title={'Transfer'}
      subtitle={toTitleCase(entry.payload.account_type ?? '')}
      amount={absCentsToDollar(entry.amount)}
      isFailed={entry.status === 'failed'}
      subText={toTitleCase(entry.status)}
    />
  );
};

const EarningCard = ({ entry }: Props) => {
  if (entry.payout) {
    return <TransferCard entry={entry} />;
  }
  if (entry.card_link) {
    return <PurchaseCard entry={entry} />;
  }
  return <DonationCard entry={entry} />;
};

export { EarningCard };
